import { VALID_REPORT_TYPES } from 'tio-reporting/utils/dataset-utils';

/**
 * The report types the partner report viewer may open, matching the listing that links to
 * it. The consolidated page offers every builder product; the page it replaced offered TA
 * alone, so the flag-off answer stays exactly that. Dashboards are never included — they
 * open in the dashboard viewer, and the report viewer cannot render a widget grid.
 *
 * @param consolidated whether the consolidated Reports page is live
 */
export function partnerViewerReportTypes(consolidated: boolean): string[] {
  return consolidated ? [...VALID_REPORT_TYPES] : ['tas'];
}
